import { render, staticRenderFns } from "./MetatextNewEdit.vue?vue&type=template&id=2d359366&scoped=true&"
import script from "./MetatextNewEdit.vue?vue&type=script&lang=js&"
export * from "./MetatextNewEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d359366",
  null
  
)

export default component.exports